import { User } from 'configcat-react';
import { buildConfigCatUser } from 'contexts/configcat/buildConfigCatUser';
import { useRouteEntities } from 'contexts/RouteEntityContext';
import { useUser } from 'contexts/UserContext';
import { createContext, ReactNode, useContext, useMemo } from 'react';

const Context = createContext<User | undefined>(undefined);

export function ConfigCatUserProvider({ children }: { children: ReactNode }) {
    const { user } = useUser();
    const { corporation, location, isLoading } = useRouteEntities();

    const configCatUser = useMemo(() => {
        if (!user || isLoading) {
            return undefined;
        }
        return buildConfigCatUser({ user, corporation, location });
    }, [user, corporation, location, isLoading]);

    return <Context.Provider value={configCatUser}>{children}</Context.Provider>;
}

export function useConfigCatUser(): User | undefined {
    return useContext(Context);
}
